// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1WJ6r","name":"Header_name__1BtPc","birthday":"Header_birthday__3qK3C","skeleton":"Header_skeleton__361dR"};